import React, { useContext } from "react";
import { VegaButtonLink, VegaBox } from "@heartlandone/vega-react";
import { ROUTES_PATH, MODULE } from "Chore/Constants";
import { useNavigate } from "react-router-dom";
import { useNavigationHistory } from 'Navigation/NavigationHistoryProvider';
import { HubContext } from "Redux/Context/context";

const { MY_ACTIVITIES } = MODULE;
const { REGISTERED, PUBLISHED } = MY_ACTIVITIES;

function ViewRegistrationAction({ activity }) {
  const { id } = activity;
  const navigate = useNavigate();
  useNavigationHistory();
  const { myActivitiesState } = useContext(HubContext);
  const { module } = myActivitiesState;

  const onViewDetialClick = () => {
    if (module === REGISTERED) {
      navigate(`${ROUTES_PATH.MY_ACTIVITY_REGISTERED_DETAIL}/${id}`);
    } else if (module === PUBLISHED) {
      navigate(`${ROUTES_PATH.MY_ACTIVITY_PUBLISHED_DETAIL}/${id}`);
    }
  };

  return (
    <VegaBox flexShrink={0} flexGrow={0}>
      <VegaButtonLink
        label="View Registration"
        icon="far fa-table"
        onVegaClick={() => onViewDetialClick()}
      />
    </VegaBox>
  );
}

export default ViewRegistrationAction;
